<template>
  <div id="login-wrapper" class="container-fluid">
    <div class="row">
      <div class="col-lg-6" id="form">
        <div class="form-wrapper">
          <div class="logo-wrapper text-center w-100">
            <img src="@/assets/servislet-kurumsal.png" class="logo" alt="Servislet">
            <div class="login-nav-wrapper">
              <router-link to="/giris-yap" class="active">Giriş Yap</router-link>
              <a href="https://www.servislet.com/kurumsal/kayit" target="_blank">Hemen Başvur</a>
            </div>
          </div>
          <div class="form-width">
            <div class="input-wrapper" id="user">
              <b-input-group class="mt-3">
                <template #prepend>
                  <b-input-group-text>
                    <img src="@/assets/icons/envolpe.png">
                  </b-input-group-text>
                </template>
                <b-form-input v-model="form.email" v-on:keyup.enter="login()"></b-form-input>
              </b-input-group>
            </div>
            <div class="input-wrapper mt-4" id="pass">
              <b-input-group class="mt-3">
                <template #prepend>
                  <b-input-group-text>
                    <img src="@/assets/icons/lock.png">
                  </b-input-group-text>
                </template>
                <b-form-input type="password" v-model="form.password" v-on:keyup.enter="login()"
                              v-if="password"></b-form-input>
                <b-form-input type="text" v-model="form.password" v-on:keyup.enter="login()" v-else></b-form-input>
                <template #append>
                  <b-input-group-text id="show-pass">
                    <img src="@/assets/icons/eye.png" class="show-pass" @click="password = !password">
                  </b-input-group-text>
                </template>
              </b-input-group>
            </div>
            <div class="forgot-pass">
              <p class="login_a">
                Şifrenizi mi unuttunuz?
              </p>
            </div>
            <div class="login">
              <button @click="login()">Giriş Yap</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 p-0" id="carousel">
        <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            indicators
            background="#ababab"
            img-width="100%"
            img-height="100%"
            style="text-shadow: 1px 1px 2px #333;"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
              caption="Avantajlı ödeme şekillerinden yararlanın!"
              text="Servislet’in çalıştığınız bankalarla kurduğu iş birlikleri sayesinde taksit planlarından yararlanabilir, alışveriş kredisi ile ihtiyaçlarınızı satın alabilir ve her zaman en avantajlı ödeme şeklinden yararlanabilirsiniz."
              img-src="/img/login/1.webp"
          ></b-carousel-slide>
          <b-carousel-slide
              caption="Ürün çeşitliliği"
              text="Servislet Kurumsal’ın marka ve model çeşitliliği oldukça zengindir. Geniş ürün portföyü ile her araç tipine, her ebatta ve her ihtiyaca uygun lastik çeşitlerine kolayca ulaşırsınız."
              img-src="/img/login/2.webp"
          ></b-carousel-slide>
          <b-carousel-slide
              caption="Toplu arama özelliğinden yararlanın, zamandan tasarruf edin!"
              text="Tüm araçlarınıza uygun lastikleri tek sayfada görüntüleyebilir, ihtiyacınıza uygun lastiği kolayca seçebilir ve hemen satın alabilirsiniz."
              img-src="/img/login/3.webp"
          ></b-carousel-slide>
          <b-carousel-slide
              caption="Daha çok al, daha az öde!"
              text="Toplu satın alımlarda avantajlı fiyatlardan yararlanabilirsiniz. Araçlarınız için ihtiyacınız olan lastik ve ek servis adedi arttıkça daha az ödersiniz."
              img-src="/img/login/4.webp"
          ></b-carousel-slide>
        </b-carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      slide: 0,
      sliding: null,
      password: true,
      form: {
        email: '', // barankurumsal@servislet.com
        password: '' // 12345678
      }
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    login() {
      this.$axios.post(`/web/corporate/auth/login`, {
        email: this.form.email,
        password: this.form.password
      }).then((response) => {
        if (response.status) {
          localStorage.setItem("userData", JSON.stringify(response.data.responseData));
          this.$router.push('/')
          window.location.reload()
        }
      }).catch((error) => {
        this.$swal.fire({
          position: 'top-end',
          icon: 'error',
          toast: true,
          text: error.response.data.uiMessage,
          showConfirmButton: false,
          timer: 1500
        })
      })
    }
  }
}
</script>

<style scoped>
#login-wrapper img {
  max-width: 290px;
}

#login-wrapper .logo {
  margin-bottom: 2rem;
}

#form {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  max-width: 52%;
  z-index: 999;
  background: #eaeaea;
}

#carousel {
  position: absolute;
  right: 0;
  width: 100%;
  max-width: 51%;
}

.input-wrapper {
  width: 100%;
  position: relative;
}

.input-wrapper input {
  color: #1c1c1c;
  border: 1px solid #DEDEDE;
  background-color: #EAEAEA;
  padding: 6px 12px;
  border-radius: 5px;
}

.forgot-pass p {
  text-align: right;
  cursor: pointer;
  transition: .5s;
  margin-top: 1rem;
}

.forgot-pass p:hover {
  transition: .5s;
  text-decoration: underline;
}

.login button {
  width: 100%;
  background: #1c1c1c;
  border: 1px solid #1c1c1c;
  color: #f4f4f4;
  border-radius: 5px;
  outline: none;
  transition: .5s;
  height: 40px;
}

.login button:hover {
  transition: .5s;
  background: #06a5d0;
  border-color: #06a5d0;
  transition: .5s;
}

.form-width {
  width: 420px;
}

-->
.input-group-text {
  background: #eaeaea;
}

.carousel-item {
  max-height: 100vh;
}

.name-input {
  border-left: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.password-input {
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* tablet */
@media screen and (max-width: 950px) and (min-width: 551px) {
  #form {
    height: 40vh;
    position: unset;
    max-width: 57%;
  }

  #carousel {
    padding-right: 0;
  }

  .form-width {
    width: auto;
  }
}

/* mobile */
@media screen and (max-width: 1200px) {
  #login-wrapper {
    height: 100vh;
  }

  #login-wrapper > .row {
    gap: 2rem;
  }

  #form {
    max-width: 100%;
    position: unset;
    margin-top: 30%;
  }

  .form-width {
    width: auto;
  }
}

#carousel {
  height: 100vh;
}

@media only screen and (max-width: 600px) {
  #carousel {
    padding: 0 !important;
  }
}

@media only screen and (max-width: 1200px) {
  #carousel {
    display: none;
    padding: 0 !important;
  }
}
</style>
